.row {
  cursor: pointer;
}

.image {
  width: 60px;
}
